const DEFAULT_PUBLIC_API_URL = 'https://getcamigo.in/api';

export const getApiUrl = () => {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;

  if (typeof window !== 'undefined') {
    const { protocol, hostname, origin } = window.location;
    const isLocalWeb = (hostname === 'localhost' || hostname === '127.0.0.1') && (protocol === 'http:' || protocol === 'https:');
    const isNativeShell = protocol === 'capacitor:' || protocol === 'ionic:';

    if (isNativeShell) {
      return DEFAULT_PUBLIC_API_URL;
    }

    if (!isLocalWeb) {
      return `${origin}/api`;
    }

    return 'http://localhost:3001/api';
  }

  return DEFAULT_PUBLIC_API_URL;
};

export const API_URL = getApiUrl();
